
import { RETRIEVE_SESSION_FRONTEND } from "../actions/types";

const initialState = {};

const sessionFrontendReducer = (session = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case RETRIEVE_SESSION_FRONTEND:
            return payload;

        default:
            return session;
    }
};

export default sessionFrontendReducer;